import { useState, forwardRef,  useEffect, useCallback } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import { BotonBorrar } from "../../Utils/BotonBorrar.jsx";
import SeccionPageHeader from '../../Utils/SeccionPageHeader.jsx';
import CargandoSpinner from '../../Utils/CargandoSpinner.jsx';
import { FaCalendar } from 'react-icons/fa';

registerLocale('es', es);
setDefaultLocale('es');
import PropTypes, { func } from 'prop-types';
import { Button, Card } from 'react-bootstrap';

const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            ref={ref}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input value={value} readOnly className='widthCalendar' style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }}/>
            <FaCalendar size={20} color="black"/>
        </button>
        ));

CustomInput.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
};

function BorrandoAtencion(row, Borraratencion){
    return (
        <div>
            <BotonBorrar Borrar={Borraratencion} row={row} />
        </div>
    );
}

export default function derechoidentidad(){
    const [ Cargando, setCargando] = useState(false);
    const { token, user, sedeActual } = useAuth();
    const [ derivacionesRegistraduria, setDerivacionesRegistraduria] = useState([]);
    const [ swalProps, setSwalProps] = useState({});
    
    const fetchData = useCallback(async () => {
        const url = '/orientacion/consultarderivacionesregistraduria';
        setCargando(true);
        await apiService.get(url, token)
        .then(response => {
            const result = response.data;
            setDerivacionesRegistraduria(result.derivaciones);
        })
        .catch(error => {
            Mensaje('Crear formulario', `Hubo un error con la carga de datos: ${error}`);
        })
        .finally(() => {
            setCargando(false);
        });
    }, [token]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
    
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    
    async function AnularAtencion(id, idPersona, idCabeza) {
        setCargando(true);
        let url;
        url = '/orientacion/anularatencionidentidadefectiva';
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        const obj = {
            idDetalleAtencion: id,
            idPersona: idPersona,
            userId: user,
            idCabeza: idCabeza,
            sede: sedeActual,
            fecha: formattedDate
        };
        try {
            const response = await apiService.post(url, obj, token);
            if(response.status === 200){
                Mensaje('Anular atencion', JSON.stringify(response.data.message));
                fetchData(); // Refresh the data after successful operation
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Anular atencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Anular atencion', JSON.stringify(error.response.data));
            }
        } finally {
            setCargando(false);
        }
    }

    async function handleEfectivo(id, idPersona, idCabeza) {
        setSwalProps({
            show: true,
            title: 'Registrar atención',
            html: `
                <label for="swal-input-date">Por favor seleccione la fecha de atención</label>
                <input id="swal-input-date" type="date" class="swal2-input" placeholder="Seleccione una fecha">
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Registrar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const value = document.getElementById('swal-input-date').value;
                if (!value) {
                    return Promise.reject('Debe seleccionar una fecha');
                }
                return value;
            },
            didClose: () => setSwalProps({}),
            onConfirm: async (result) => {
                const fecha = result;
                if (!fecha) {
                    setSwalProps({
                        show: true,
                        title: 'Fecha requerida',
                        text: 'Debe seleccionar una fecha antes de registrar la atención.',
                    });
                    return;
                }
                setCargando(true);
                let url = '/orientacion/registraratencionidentidadefectiva';
                const obj = {
                    idDetalleAtencion: id,
                    idPersona: idPersona,
                    userId: user,
                    idCabeza: idCabeza,
                    sede: sedeActual,
                    fecha: fecha.value
                };
                try {
                    const response = await apiService.post(url, obj, token);
                    if(response.status === 200){
                        setSwalProps({
                            show: true,
                            title: 'Registrar atención',
                            text: JSON.stringify(response.data.message),
                        });
                        fetchData();
                    }
                } catch (error) {
                    setSwalProps({
                        show: true,
                        title: 'Registrar atención',
                        text: error?.response?.data?.errors || error?.response?.data || 'Error',
                    });
                } finally {
                    setCargando(false);
                }
            }
        });
    }

    async function handleAnular(id, idPersona, idCabeza) {
        setSwalProps({
            show: true,
            title: 'Derecho identidad no realizado',
            text: '¿Estás seguro de que deseas marcar esta derivación como no realizada?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                AnularAtencion(id, idPersona, idCabeza)
                setSwalProps({ ...swalProps, show: false });
            },
            didClose: () => {
                setSwalProps({ ...swalProps, show: false });
            },
        });
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Derecho identidad" idCabezaFamilia="0" url={`/`} nombreurl="Inicio" nombreform="Derecho identidad" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <Card>
                            <Card.Header>
                                <h3 className="card-title">Lista derivaciones derecho identidad pendientes</h3>
                            </Card.Header>
                            <Card.Body>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover table-sm">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Fecha</th>
                                                <th>Id persona</th>
                                                <th>Nombre persona</th>
                                                <th>Observaciones</th>
                                                <th>Sede</th>
                                                <th>Nombre usuario</th>
                                                <th>Id Cabeza familia</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {derivacionesRegistraduria && derivacionesRegistraduria.length > 0 ? (
                                                derivacionesRegistraduria.map((row) => (
                                                    <tr key={row.id}>
                                                        <td>{row.id}</td>
                                                        <td>{row.det_fecha}</td>
                                                        <td>{row.det_idpersona}</td>
                                                        <td>{row.nombre}</td>
                                                        <td>{row.det_observaciones}</td>
                                                        <td>{row.det_sede}</td>
                                                        <td>{row.usuario}</td>
                                                        <td>{row.gru_idcabezafamilia}</td>
                                                        <td>
                                                            <Button 
                                                                variant="primary" 
                                                                style={{ color: "#000", fontWeight: "bold" }}
                                                                onClick={() => handleEfectivo(row.id, row.det_idpersona, row.gru_idcabezafamilia)}
                                                            >
                                                                Efectivo
                                                            </Button>
                                                            <Button 
                                                                variant="warning"
                                                                style={{ color: "#000", fontWeight: "bold" }}
                                                                onClick={() => handleAnular(row.id)}
                                                            >
                                                                No realizado
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7} style={{ textAlign: "center" }}>No hay derivaciones registradas</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}